import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RedirectResolver } from '@box-core/resolvers';

import * as Pages from './pages';

const routes: Routes = [
  {
    path: '',
    component: Pages.UsefulLinksShellPage,
    children: [
      {
        path: 'terms',
        resolve: { redirect: RedirectResolver },
        component: class DummyComponent {},
        data: {
          name: 'Terms Page',
          breadcrumbName: 'terms_and_conditions_of_use',
          redirectTo: '/account/terms/box-terms-of-use'
        }
      },
      {
        path: 'privacy',
        resolve: { redirect: RedirectResolver },
        component: class DummyComponent {},
        data: { name: 'Privacy Page', breadcrumbName: 'privacy_update', redirectTo: '/account/personal-data/policy' }
      },
      { path: 'gdpr', component: Pages.UsefulLinksGDPRPage, data: { name: 'GDPR Page', breadcrumbName: 'GDPR' } },
      {
        path: 'faqs',
        resolve: { redirect: RedirectResolver },
        component: class DummyComponent {},
        data: { name: 'FAQs Page', breadcrumbName: 'faqs_', redirectTo: '/account/faqs' }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LegalRoutingModule {}
